import React from "react";
import { useTranslation } from "react-i18next";

// common
import {
  ModalText,
  ModalLayout,
  LargeModalStyling,
  MoreModalButtons,
} from "common/modal";

const { LargeModal, LargeModalCreditInfo } = LargeModalStyling;
const { ConfirmationText } = ModalText;
const { ModalRow } = ModalLayout;
const { ModalButtonYellow, ModalButtonBlue, ButtonContainer } =
  MoreModalButtons;

type deletePaymentModalType = {
  visible: boolean;
  onCloseModal: () => void;
  onRemovePaymentMethod: () => void;
};

function DeletePaymentMethodModal(props: deletePaymentModalType) {
  const { t } = useTranslation("my_billing");
  const { visible, onCloseModal, onRemovePaymentMethod } = props;

  return (
    <LargeModal
      title={t("DELETE PAYMENT DETAILS")}
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
    >
      <ConfirmationText>
        {t("Please confirm that you want to delete this payment method!")}
      </ConfirmationText>
      <ModalRow gutter={24}>
        <ButtonContainer xs={20} sm={20} md={12}>
          <ModalButtonYellow
            type="primary"
            onClick={() => {
              onCloseModal();
            }}
          >
            {t("KEEP THEM")}
          </ModalButtonYellow>
        </ButtonContainer>
        <ButtonContainer xs={20} sm={20} md={12}>
          <ModalButtonBlue
            type="primary"
            onClick={() => {
              onRemovePaymentMethod();
              onCloseModal();
            }}
          >
            {t("DELETE FOREVER")}
          </ModalButtonBlue>
        </ButtonContainer>
      </ModalRow>
      <LargeModalCreditInfo>
        <span>
          {t(
            'If you do not want to be charged anymore, cancel your subscription under "Credits". You will never be charged again after cancelling or pausing your subscription. You can keep your credit card details here for the future if you want to buy credits again or permanently delete them.'
          )}
        </span>
      </LargeModalCreditInfo>
    </LargeModal>
  );
}

export default DeletePaymentMethodModal;
